module.exports = __webpack_public_path__ + "static/img/banner.db9dcbc2.jpg";